export default "__VITE_ASSET__Bq0IE8DA__"